import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { obterConfiguracaoParametro, obterDecursoDePrazo, obterToken } from '../../api/suporteAPI';
import auth  from '../../auth/Auth';
import { MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA, MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB } from '../../common/Mensagens';

export interface SuporteState {
  valorConfiguracao: string;
  decursoPrazo: number | null;
  token:string;
  versaoMinimaAceitavel: boolean;
}

const initialState: SuporteState = {
  valorConfiguracao: '',
  decursoPrazo: null,
  token: '',
   versaoMinimaAceitavel: true
};

export const getConfiguracaoParametro = createAsyncThunk(
  'suporte/getConfiguracaoParametro',
  async (chaveConfiguracao: string) => {
    return obterConfiguracaoParametro(chaveConfiguracao);
  }
);

export const getDecursoPrazo = createAsyncThunk(
  'suporte/getDecursoPrazo',
  async () => {
    if(!auth.getDecursoPrazoCache()){
      const decurso = await obterDecursoDePrazo();
      auth.setDecursoPrazo(decurso);
    }

    return auth.getDecursoPrazoCache()
  }
);

export const getToken = createAsyncThunk(
  'suporte/getToken',
  async () => {
    return obterToken();
  }
);

export const suporteSlice = createSlice({
  name: 'suporteSlice',
  initialState,
  reducers: {
    limpar: (state) => {
      state.valorConfiguracao = initialState.valorConfiguracao;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConfiguracaoParametro.fulfilled, (state, action) => {
        state.valorConfiguracao = action.payload;
      })
      .addCase(getDecursoPrazo.fulfilled, (state, action) => {
        state.decursoPrazo = action.payload;
      })
      .addCase(getDecursoPrazo.rejected, (state, action) => {
        if (
          action.error?.message &&
          (action.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA) ||
            action.error?.message.includes(MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB))
        ) {
          state.versaoMinimaAceitavel = false;
        }
      })
      .addCase(getToken.fulfilled, (state, action) => {
        state.token = action.payload;
      })
  },
});

export const { limpar } = suporteSlice.actions;
export const selectConfiguracaoParametro = (state: RootState) => state.suporte.valorConfiguracao;
export const selectDecursoPrazo = (state: RootState) => state.suporte.decursoPrazo;
export const selectToken = (state: RootState) => state.suporte.token;
export const selectVersaoMinimaAceitavel = (state: RootState) => state.suporte.versaoMinimaAceitavel;
export const selectState = (state: RootState) => state.suporte;

export default suporteSlice.reducer;
